import {
  Identifiable,
  Resource,
  Project,
  ProjectResource,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function addPlanzoneResourceToProject(httpClient: HttpClient, linker: Linker) {
  return (project: Identifiable<Project>, resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<ProjectResource>>>({
        endpoint: "/projectMembers",
        method: HttpMethods.POST,
        data: resource.role
          ? {
              member: `resources/${resource.uuid}`,
              role: `roles/${resource.role.uuid}`,
              project: `projects/${project.uuid}`,
            }
          : {
              member: `resources/${resource.uuid}`,
              project: `projects/${project.uuid}`,
            },
      })
      .then(linker.linkProjectResource);
}

export { addPlanzoneResourceToProject };
